// The environment chip in the header ("Dev", "Stage"): read from the admin host name, which the
// deployments name `nexus-<env>-admin.<domain>` (dev: nexus-dev-admin.allcode.com). Production and
// any host that does not say are shown no chip; a local stack says "Local".

export type EnvironmentTone = "dev" | "stage" | "local";

export interface EnvironmentChip {
  label: string;
  tone: EnvironmentTone;
}

export function environmentFromHost(hostname: string): EnvironmentChip | null {
  const host = hostname.toLowerCase();
  if (host === "localhost" || host === "127.0.0.1" || host === "[::1]" || host.endsWith(".localhost")) {
    return { label: "Local", tone: "local" };
  }
  const labels = host.split(".");
  const first = labels[0] ?? "";
  const words = first.split("-");
  if (words.includes("dev") || words.includes("development")) return { label: "Dev", tone: "dev" };
  if (words.includes("stage") || words.includes("staging")) return { label: "Stage", tone: "stage" };
  return null;
}
